import { Space, Spin } from "antd";
import useWindowWidth from "../../hooks/useWindowWidth";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import {
  LoginOutlined,
  MoneyCollectOutlined,
  SnippetsOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { useEffect, useState } from "react";
import httpclient from "../../service/httpclient";
import "./RecruitmentQuestionMembership.scss";

const RecruitmentQuestionMembership = () => {
  const { deviceType } = useWindowWidth();
  const history = useHistory();

  const [productMembership, setProductMembership] = useState(null);
  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      setProductMembership(res);
    }, []);
  }, []);

  return (
    <>
      <Space style={{ marginTop: 24 }} size="middle" wrap>
        <img
          src="https://cdn.datongbei.com/icdesign-logo.png"
          style={{ height: 60 }}
          alt="logo"
        />
        <span style={{ fontSize: 28, fontWeight: "bold", color: "#4970a2" }}>
          题库Pro会员
        </span>
      </Space>

      {productMembership ? (
        <div
          style={{
            width: deviceType === "mobile" ? "90%" : "max(60%, 500px)",
            maxWidth: 640,
          }}
          className="membership-info-container"
        >
          <div className="membership-info-header">
            <div className="membership-info-title">一年期会员</div>
            <div className="membership-info-price">
              ¥{productMembership.calculated_price / 100}
              <span className="membership-info-original-price">
                ¥{productMembership.price / 100}
              </span>
            </div>
            <div className="membership-info-daily-price">
              平均{Math.round(productMembership.calculated_price / 365) / 100}
              元/天
            </div>
            <div className="membership-info-promo-box">
              <div className="membership-info-promo-text">
                优惠规则：早鸟优惠<b>100元</b> + 用户已购题单抵扣
                <b>{productMembership.total_list_cost / 100}元</b>
                ，至多减至0.01元
              </div>
            </div>
            <div className="membership-info-btn-container">
              <button
                className="membership-info-btn"
                onClick={() => history.push("/checkout/product_memberships/1")}
              >
                开通会员
              </button>
            </div>
          </div>
          <div
            style={{ padding: deviceType === "mobile" ? "0 14px" : "0 20px" }}
            className="membership-info-content"
          >
            <div className="membership-info-benefits-title">会员权益</div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <VideoCameraOutlined />
                  解锁题单
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  题库价值159+69+69=297元
                </div>
                <div className="membership-info-benefit-desc">
                  三个提单全部解锁
                </div>
              </div>
            </div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <SnippetsOutlined />
                  模拟考试
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  Pro会员专属模考福利
                </div>
              </div>
            </div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <LoginOutlined />
                  新题速递
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  秋招季200+新题更新
                </div>
                <div className="membership-info-benefit-desc">
                  100+新题视频解答！
                </div>
              </div>
            </div>
            <div className="membership-info-benefit">
              <div className="membership-info-benefit-title">
                <Space>
                  <MoneyCollectOutlined />
                  专栏福利
                </Space>
              </div>
              <div className="membership-info-benefit-info">
                <div className="membership-info-benefit-desc">
                  专栏半价优惠券一张
                </div>
                <div className="membership-info-benefit-desc">
                  专栏50元代金券一张
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Spin style={{ marginTop: 64 }} />
      )}
    </>
  );
};

export default RecruitmentQuestionMembership;
